import React from "react";
import { Link } from "react-router-dom";
import './App.css'
import Omr50Page from "./Omr50Page";
import Omr100Page from "./Omr100Page";

export default function OMRMainPage() {
  const [choose, setChoose] = React.useState(0)
  return (
    <main className="page home-page">
      <section className="panel hero-panel">
        <h1>Select category</h1>

        <div className="category-grid">
          <div className="category-card" to="/50"
            style={{ backgroundColor: choose == 1 ? "#eee" : "#fff", cursor: "pointer" }}
            onClick={() => {
              setChoose(1)
            }}
          >
            <strong>50 Questions</strong>
          </div>

          <div className="category-card" to="/100"
            style={{ backgroundColor: choose == 2 ? "#eee" : "#fff", cursor: "pointer" }}
            onClick={() => {
              setChoose(2)
            }}
          >
            <strong>100 Questions</strong>
          </div>
        </div>
      </section>
      {choose == 1 &&
        <Omr50Page />
      }
      {choose == 2 &&
        <Omr100Page />
      }
    </main>
  );
}
